import React from 'react';

import {
   FormControl,
   FormControlLabel,
   RadioGroup,
   Radio,
  } from '@mui/material';

const SelectResearcherLevel = ({ style, onChange, value, row = false, name = 'researcher-level' }) => {
  return (
    <FormControl style={style}>
      <RadioGroup
        aria-labelledby="permissions-radio-buttons-group-label"
        name={name}
        onChange={onChange}
        value={value ? `${value}` : ''}
        row={row}
      >
        <FormControlLabel value={'1'} control={<Radio />} label="Level 1" />
        <FormControlLabel value={'2'} control={<Radio />} label="Level 2" />
        <FormControlLabel value={'3'} control={<Radio />} label="Level 3" />
    </RadioGroup>
    </FormControl>
  )
}

export default SelectResearcherLevel;